import ExpenseTypeToken from '@apps/finance/admin/tokens/expense_type'
import ProjectToken from '@apps/finance/admin/tokens/project'
import Form from '@admin/components/form'
import PropTypes from 'prop-types'
import React from 'react'

class New extends React.Component {

  static contextTypes = {
    form: PropTypes.object
  }

  static propTypes = {
    projectEndpoint: PropTypes.string,
    onSubmit: PropTypes.func
  }

  _handleCancel = this._handleCancel.bind(this)
  _handleSubmit = this._handleSubmit.bind(this)
  _handleSuccess = this._handleSuccess.bind(this)

  render() {
    return <Form { ...this._getForm() } />
  }

  _getForm() {
    const { projectEndpoint } = this.props
    return {
      title: 't(New Allocation)',
      saveText: 'Done',
      onSubmit: this._handleSubmit,
      onCancel: this._handleCancel,
      onSuccess: this._handleSuccess,
      sections: [
        {
          fields: [
            { label: 't(Project)', name: 'project_id', required: true, type: 'lookup', endpoint: projectEndpoint, valueKey: 'id', textKey: 'display', format: ProjectToken },
            { label: 't(Expense Type)', name: 'expense_type_id', required: true, type: 'lookup', endpoint: '/api/admin/finance/expense_types', valueKey: 'id', textKey: 'display', format: ExpenseTypeToken },
            { label: 't(Description)', name: 'description', required: true, type: 'textfield' },
            { label: 't(Amount)', name: 'amount', required: true, type: 'moneyfield' }
          ]
        }
      ]
    }
  }

  _handleCancel() {
    this.context.form.pop()
  }

  _handleSubmit(allocation) {
    this.props.onSubmit(allocation)
    return true
  }

  _handleSuccess(result) {
    this.context.form.pop()
  }

}

export default New
